import { respond } from '@fr/rwd';
import formValidation from '@fr/form-validation';

const website = {};





/**
 * Self anonymous invoking function that initializes all the component that need to be instancied or initialized for
 * any page calling this core initialization.
 */
(function() {

  // On document ready
  $(function() {





      /* LANGUAGE PROMPT
       ============================================================================ */

      if($('html[class*="page"]').length > 0 && $('html[class*="js-no-lang-prompt"]').length === 0) {

        $.ajax({
            type: 'GET',
            url: `/alternativeLocale?pathname=${ window.location.pathname }`,
            dataType: 'text'
        })
        .done(function( domainFromServer ) {

          if(typeof domainFromServer !== 'undefined' && domainFromServer.indexOf(window.location.host) == -1) {

              const question = document
                                .querySelector('meta[property="lang_prompt-question"]')
                                  .getAttribute('content'),
                    accept   = document
                                .querySelector('meta[property="lang_prompt-accept')
                                .getAttribute('content'),
                    reject   = document
                                .querySelector('meta[property="lang_prompt-reject')
                                .getAttribute('content');

                const notificationMarkup = `
                  <div data-cookie="lang_prompt"
                      class="[ notification  notification--shadow ]  js-notification"
                      style="display: none;">
                    <div class="notification__info  js-notification__info">
                      ${ question }&nbsp;
                      <a href="${ domainFromServer }">${ accept }</a>
                    </div>
                    <button
                      class="js-notification__close  notification__close">
                        ${ reject }
                    </button>
                  </div>
                `;

                const notifs = document
                                .querySelector('#notifications-placeholder');

                notifs.innerHTML += notificationMarkup;

                FR.commons
                    .initNotification(document
                      .querySelector('[data-cookie="lang_prompt"]'));

            }
        });
      }





/* CALCULATOR FORM
 ============================================================================ */

    // Calculator Form Validation.
    if($('.calculator__form').length > 0) {

        $('.calculator__form').submit(function(event) {
					const $form           = $(this),
								isForTypeForm		= $form.attr('data-type-form') === "true";
					let   valid           = true;

					if (isForTypeForm) return;

					valid = formValidation.validateFields($form, '[name="ext_flightNumber01"], [name="flight_date"], [name="depAirportIata01"], [name="arrAirportIata01"]');

					if(!valid) {
						event.preventDefault();
					} else {
						const $dateField             = $form.find('[name="ext_flightDate01"]'),
									$dateFieldWithAirports = $form.find('[name="flightDate01"]'),
									$depAirportField       = $form.find('[name="depAirportIata01"]'),
									depAirportSubmitValue  = $depAirportField.attr('data-submit'),
									$arrAirportField       = $form.find('[name="arrAirportIata01"]'),
									arrAirportSubmitValue  = $arrAirportField.attr('data-submit');

						$depAirportField.val(depAirportSubmitValue);
						$arrAirportField.val(arrAirportSubmitValue); 
						$dateField.val($form.find('[name="flight_date_submit"]').val());
						$dateFieldWithAirports.val($form.find('[name="flight_date_submit"]').val());

						return;
					}

        });

    }

    // Click on calculator date icons to trigger datepicker.
    if($('.calculator').length > 0) {

      $('.calculator').on('click','.js-datepicker__toggle', function(e) {
          // The input holding the picker should be the non-hidden one.
          $(this).siblings('input:not([hidden])').pickadate('picker').open();
          e.preventDefault();
          e.stopPropagation();
      });

    }

/* FOOTER RESIZING
 ============================================================================ */


      if ($('body').data('language') === 'de') {
          // Rezizing footer components
          if($('#footerSupportedBy').length > 0) {
              respond($('#footerSupportedBy'), function() {
                  if($('#footerSupportedBy').outerHeight() < $('#footerTrustpilotBadge').outerHeight()) {
                      $('#footerSupportedBy').outerHeight($('#footerTrustpilotBadge').outerHeight());
                  } else {
                      $('#footerTrustpilotBadge').outerHeight($('#footerSupportedBy').outerHeight());
                  }
              });
          }

          if($('#footerFlags').length > 0) {
              respond($('#footerFlags'), function() {
                  if($('#footerFlags').outerHeight() < $('#footerOtherBadges').outerHeight()) {
                      $('#footerFlags').outerHeight($('#footerOtherBadges').outerHeight());
                  } else {
                      $('#footerOtherBadges').outerHeight($('#footerFlags').outerHeight());
                  }
              });
          }

          if($('#footerBePartOfOurTeam').length > 0) {
              // Pushes, if necessary the #footerBePartOfOurTeam button to the
              // same bottom position of the #footerFlags.
              respond($('#footerBePartOfOurTeam'), function() {

                var footerFlagsBottom  = $('#footerFlags').offset().top + $('#footerFlags').outerHeight(),
                    footerBePartBottom = $('#footerBePartOfOurTeam').offset().top + $('#footerBePartOfOurTeam').outerHeight(),
                    diff               = footerFlagsBottom - footerBePartBottom;

                if(diff > 0) {
                  $('#footerBePartOfOurTeam')[0].style.paddingTop = diff + 'px';
                }
              });
          }
      } else
      /**WEB-1356 Delete DEKRA & Vergleich.org Logos from international Domains
       *
       * 1. - Center content of trustpilot overview badge vertically within parent
       * 2. - Float social media icons to the right of facebook button and align to the top
       * 3. - Align heights of left (trustpilot overview) and right (Supported By EU and Flags) block
       *
       **/
      {
        if ($('#footerOtherBadges').length > 0) {
          $('#footerOtherBadges').hide();
        }
        if ($('#footerSupportedByAndFlagsContainer').length > 0 && $('#footerTrustpilotBadge .trustpilot-overview').length > 0) {
          $('#footerTrustpilotBadge .trustpilot-overview').addClass('trustpilot-overview__centered');/* [1] */
          $('#facebookButton').removeClass('block');/* [2] */
          $('.footer-socialmedia-icon').css('vertical-align', 'top');/* [2] */
          $('#footerTrustpilotBadge').outerHeight($('#footerSupportedByAndFlagsContainer').outerHeight());/* [3] */
       }
      }

  });

}());


export default website;
